//
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
// ui
import { ThemeProvider } from "@mui/material/styles";
// store
import { StoreContext } from "../../store/StoreProvider";

import globalTheme from "../config";

const CustomThemeProvider = ({ children }) => {
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { theme } = state;
  const { fontSizeScale } = theme;
  // local state
  const [curGlobalTheme, setCurGlobalTheme] = useState(null);

  // theme
  useEffect(() => {
    const newTheme = globalTheme({ fontSizeScale });
    setCurGlobalTheme(newTheme);
  }, [fontSizeScale]);

  return (
    curGlobalTheme && (
      <ThemeProvider theme={curGlobalTheme}>{children}</ThemeProvider>
    )
  );
};

CustomThemeProvider.propTypes = {
  children: PropTypes.node,
};

CustomThemeProvider.defaultProps = {
  children: null,
};

export default CustomThemeProvider;
